export const initialStates = {
allTeams: [],
teamTransactions:[],
teamList:[],
pendingList:[],
teamProfile:[]
};
  